import { Controller } from "@hotwired/stimulus"

// Opens a modal at one of its sections: on the trigger's click, scrolls to the section once the
// modal is shown, and again each time a lazy content frame loads inside it. The listeners last
// until the modal is hidden, so opening it another way does not scroll.
//
// Everything comes from action params, so the controller composes: it sits on the trigger or on
// any ancestor shared by many triggers, next to other controllers and actions on the same click
// (Bootstrap `data-bs-toggle`, `modal--navigation#openFromNested`). Prefer the `anchor_id:` option
// of `Ui::Modal::ButtonComponent`, which writes the markup:
//
//   data-controller="modal--anchor"
//   data-action="modal--anchor#arm …"
//   data-modal--anchor-modal-id-param="<modal id>"
//   data-modal--anchor-section-id-param="<section id inside the modal>"
export default class extends Controller {
  disconnect () {
    this.disarm?.()
  }

  arm ({ params: { modalId, sectionId } }) {
    const modal = document.getElementById(modalId)
    if (!modal || !sectionId) return

    this.disarm?.()
    const scroll = () => {
      const section = document.getElementById(sectionId)
      if (section && modal.contains(section)) section.scrollIntoView({ block: "start" })
    }
    const disarm = () => {
      modal.removeEventListener("shown.bs.modal", scroll)
      modal.removeEventListener("turbo:frame-load", scroll)
      modal.removeEventListener("hidden.bs.modal", disarm)
      if (this.disarm === disarm) this.disarm = null
    }

    modal.addEventListener("shown.bs.modal", scroll)
    modal.addEventListener("turbo:frame-load", scroll)
    modal.addEventListener("hidden.bs.modal", disarm)
    this.disarm = disarm
  }
}
